<div mat-dialog-title class="title-container">
    <div class="title-text">{{'DOC_PICKER_TITLE' | translate}}</div>
    @if (workspaceService.docsLoaded() && docType!=='pdf') {
    <button mat-flat-button color="primary" (click)="insertNew()">
        {{(docType==='map' ? 'NEW_MAP' : 'NEW_DOC') | translate}}
    </button>
    }
</div>
<mat-dialog-content>
    @if (workspaceService.docsLoaded()) {
    @if (docType==='map') {
    <app-doc-picker-table type="map" [files]="this.workspaceService.maps()" (selected)="selectedFile($event)"
        (doubleClicked)="insertInDocument()"></app-doc-picker-table>
    } @else if (docType==='doc') {
    <app-doc-picker-table type="doc" [files]="this.workspaceService.docs()" (selected)="selectedFile($event)"
        (doubleClicked)="insertInDocument()"></app-doc-picker-table>
    } @else if (docType==='pdf') {
    <app-doc-picker-table type="pdf" [files]="this.workspaceService.pdfs()" (selected)="selectedFile($event)"
        (doubleClicked)="insertInDocument()"></app-doc-picker-table>
    }
    } @else {
    <div class=" no-content-container">
        <div translate>WAIT_A_MOMENT</div>
    </div>
    }
</mat-dialog-content>
<mat-dialog-actions class="action-bar">
    @if (workspaceService.docsLoaded()) {
    <div>
        @if (hasTableDocs()) {
        <button mat-stroked-button [mat-dialog-close]="true">{{'CANCEL' | translate}}</button>
        <button mat-flat-button color="primary"
            [disabled]="!workspaceService.docsLoaded() || !hasTableDocs() || selectedDoc===null"
            (click)="insertInDocument()">{{'ATTACH_TO_NODE' | translate}}</button>
        } @else {
        <button mat-flat-button [mat-dialog-close]="true">{{'BUTTON_OK' | translate}}</button>
        }
    </div>
    }
</mat-dialog-actions>